<template>
    <div class="flex align-center justify-center" :style="{display: display}">
        <div :style="{height: hasMP4?'auto':0,width: hasMP4?'auto':0,}" class="videoPlayerView">
            <video controls="controls" class="flex-cm" ref="video"
                   style="max-height: calc(100vh - 80px);"
                   id="mp4-player"
                   :src="src" :preload="true">
            </video>
        </div>
        <div :style="{height: hasMP4?0:'auto',width: hasMP4?0:'auto'}" class="videoPlayerView">
            <div class="videoPlayer">
                <video id="m3u8-player"
                       preload="auto" width="1200" height="750"
                       playsinline webkit-playsinline>
                </video>
            </div>
        </div>
    </div>
</template>

<script>
  import TCPlayer from 'tcplayer.js';
  import 'tcplayer.js/dist/tcplayer.min.css';
  export default {
    props: {
      id: {
        type: String,
        value: ''
      },
      src: {
        type: String,
        value: ''
      },
      poster: {
        type: String,
        value: '',
      },
    },
    components: {

    },
    data() {
      return {
        display:'',
        hasMP4:false,
      }
    },
    watch: {
      src(newVal,oldVal){
        this.hasMP4=!(newVal.indexOf('.m3u8')>-1)
        console.log('watch.this.player',this.hasMP4,newVal)
        if(this.hasMP4){
          this.playerMP4.src=newVal
        }else{
          this.player.src(newVal)
        }
      },
    },
    methods: {
      init(newsrc){
        let src=newsrc||this.src // 播放地址
        // player-container-id 为播放器容器 ID，必须与 html 中一致
        this.player = TCPlayer('m3u8-player', {
          sources: [{
            src: 'https://qn004.pfotoo.com/Fmy_TPVhmzgOOs-38esZvyZAZa_R',
            type: 'video/mp4'
          }],
          licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1258757496_1/v_cube.license',
          // license 地址，参考准备工作部分，在视立方控制台申请 license 后可获得 licenseUrl
          posterImage:true,
          poster:this.poster,
        });
        this.playerMP4 = document.getElementById('mp4-player');
        this.hasMP4=!(src.indexOf('.m3u8')>-1)
        if(this.hasMP4){
          this.playerMP4.src=src
        }else{
          this.player.src(src)
        }
        // player.src(url); // url 播放地址
      },
      pause(){
        this.display='none'
        if(this.player){
          this.player.pause()
        }
        if(this.playerMP4){
          this.playerMP4.pause()
        }
      },
      play(){
        this.display=''
        if(this.player) this.player.play()
        if(this.playerMP4) this.playerMP4.play()
      },
      dispose(){
        this.display='none'
        // 销毁video.js播放器
        if(this.player){
          this.player.dispose()
        }
        if(this.playerMP4){
          this.playerMP4.distory()
        }
      },
    },
    mounted() {
      console.log('videoPlayer.mounted',this.id,this.src)
      this.init()
    },
    beforeMount(){
      console.log('videoPlayer.beforeMount',this.id,this.src)

    },
    beforeDestroy() {
      this.dispose()
    },
    beforeUnmount(){
      this.dispose()
    },

  }
</script>

<style scoped>
.videoPlayerView{
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/videoPlayer.vue